import './index.scss';

(() => {
  document.addEventListener('turbolinks:load', function () {
    const $modal = $('.lifelong-upgrade-modal');
    const localStorageSlot = `lifelongUpgradePortal.${currentUser.id}`;

    function openModal() {
      $modal.addClass('lifelong-upgrade-modal--open');
      $('body').addClass('modal-open');

      UserTracker.emit('event', {
        eventName: 'lifelong modal appeared'
      });
    }

    function attachEvents() {
      const $closeButton = $modal.find('header button');
      const $upgradeButtons = $modal.find('a');

      $closeButton.on('click', () => {
        $modal.removeClass('lifelong-upgrade-modal--open');
        $('body').removeClass('modal-open');

        localStorage.setItem(localStorageSlot, true);
      });

      $upgradeButtons.on('click', event => {
        event.preventDefault();

        UserTracker.emit('event', {
          eventName: 'lifelong modal accepted'
        });

        localStorage.setItem(localStorageSlot, true);
        window.location.href = event.currentTarget.getAttribute('href');
      });
    }

    function userHasAlreadyViewed() {
      if (localStorage.getItem(localStorageSlot) === null) {
        localStorage.setItem(localStorageSlot, false);
      }

      return localStorage.getItem(localStorageSlot) === 'true';
    }

    function init() {
      if ($modal.length === 0 || userHasAlreadyViewed()) {
        return;
      }

      attachEvents();
      openModal();
    }

    init();
  });
})();
